import prioritiesTemplate from './priorities.html';

export default angular
  .module('main.locations.edit.tabs.priorities', [])

  .directive('priorityHistoryTab', () => {
    return {
      restrict: 'E',
      template: prioritiesTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $state,
                   utils,
                   $rootScope,
                   $log,
                   config,
                   $filter,
                   I18nService,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        const $t = $filter('translate');
        const REQUEST_LIMIT = 100;
        const DEFAULT_PRIORITY_ID = 1;

        $scope.locationPriorities = config.getConfigByKey('locationPriorities');
        $scope.selectedPriorityId = DEFAULT_PRIORITY_ID;
        $scope.selectedPriorityObj = $scope.locationPriorities[DEFAULT_PRIORITY_ID];

        $scope.locationTimeFormat = $t('datetime.HMS12');
        $scope.dateTimeFormat = $t('datetime.scenes.date');
        let datePickerDateTimeFormat = $t('datetime.scenes.datePickerDate');
        $scope.datepickerButton = $('#toggle-priority-datepicker');

        $scope.locale = I18nService.getLocale();
        $scope.priorities = [];
        $scope.filterDate = null;
        $scope.dateDatePickerOptions = {
          language: $scope.locale.code,
          position: 'bottom left',
          autoClose: true,
          view: 'days',
          minView: 'days',
          dateFormat: datePickerDateTimeFormat,
          maxDate: new Date(),
          timepicker: false,
          clearButton: true,
          range: true,
          // toggleSelected: false
        };

        angular.extend($scope, {
          onBackButtonClick: onBackButtonClick,
          onSearchUserMenuClick: onSearchUserMenuClick,
          onShowMoreButtonClick: onShowMoreButtonClick,
          copyToClipboard: $rootScope.copyToClipboard
        });

        init();

        function init() {
          $scope.loading = true;
          $scope.initialLoading = true;

          initWatchers();

          $q.all([
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationTimeZoneIdResource.init(),
            $scope.dataProvider.locationTimeZoneOffsetResource.init()
          ])
            .then(() => {
              $scope.timezone = $scope.dataProvider.locationTimeZoneIdResource.value;
              $scope.timezoneShift = $scope.dataProvider.locationTimeZoneOffsetResource.value;

              return getLocationPriorityHistory();
            })

            .then(() => {
              $scope.loading = false;
              $scope.initialLoading = false;
            })

            .catch((err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
              $scope.initialLoading = false;
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'selectedPriorityId',
            'filterDate'
          ], () => {
            if ($scope.initialLoading) {
              return;
            }
            getLocationPriorityHistory(true);
          });
        }

        /* Getting location priority history */
        function getLocationPriorityHistory(clearList) {
          $scope.loading = true; // To indicate history are being loaded
          let params = {
            rowCount: REQUEST_LIMIT,
            priority: $scope.selectedPriorityId
          };

          if (!$scope.filterDate || $scope.filterDate.length === 0) {
            $scope.last7Days = true;
            params.startDate = moment()
              .tz($scope.timezone)
              .startOf('day')
              .subtract(6, 'days') // 6 because current day counts
              .valueOf();
          } else {
            $scope.last7Days = false;
            let endDate = $scope.filterDate[$scope.filterDate.length - 1];
            params.startDate = moment.tz(moment($scope.filterDate[0])
              .format('L'), 'L', $scope.timezone)
              .startOf('day')
              .valueOf();
            params.endDate = moment.tz(moment(endDate)
              .format('L'), 'L', $scope.timezone)
              .endOf('day')
              .valueOf();
          }

          return $scope.dataProvider.getLocationPriorityHistory(params)
            .then((data) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              $scope.priorities = processLocationPriorities(data.priorities, clearList);
            }, (err) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              utils.handleApiError(err);
            });
        }

        function processLocationPriorities(newRecords, clearList) {
          if (clearList) {
            $scope.priorities = void 0;
          }
          if (!newRecords || newRecords.length <= 0) {
            return $scope.priorities;
          }

          let result = ($scope.priorities || []).concat(newRecords || [])
            .sort((a, b) => b.changeDateMs - a.changeDateMs);

          // Remove duplicates
          result = result
            .filter((m1, index) =>
              index === result.findIndex(m2 => angular.equals(m1, m2)));

          // Update priorities from config
          result = result.map(el => el = detectPriority(el));

          // Update priority sources form config
          result = result.map(el => el = getPrioritySource(el));

          return result;
        }

        /* Getting location priorities from config */
        function detectPriority(record) {
          let result = record;
          if (!result.category) {
            result = Object.assign(result, $scope.locationPriorities[0]);
            return result;
          }

          // Search for corresponding priority
          let detectedPriority = $scope.locationPriorities.find(el => el.id === record.category) || {};

          result = Object.assign(result, detectedPriority);
          return result;
        }

        /* Getting location priority source details */
        function getPrioritySource(record) {
          let result = record;
          if (!result || (!result.userId && !result.bundle)) {
            return result;
          }

          result.sourceId = result.userId || result.bundle;
          result.sourceName = $t(`locations.priorities.sourceTypes.${result.userId ? 'user' : 'bot'}`);
          result.sourceIcon = result.userId ? 'user-alt' : 'robot';
          result.sourceColor = result.userId ? 'green' : 'blue';
          return result;
        }

        function onBackButtonClick() {
          $scope.dataProvider.activeTab = 'events';
        }

        /* Redirects to the related source list */
        function onSearchUserMenuClick(userId) {
          if (!userId) {
            return;
          }
          $state.go('main.users.list', {searchBy: userId});
        }

        function onShowMoreButtonClick() {
          // TODO: get additional modes from history
        }
      }
    };
  })
  .name;
